export default {
    firstShortSection: {
        header: "To us, a human experience is any experience that involves at least one person.",
        description: `Whether tasting a delicious drink, or eating great food, all the way to interactions of multiple people, 
        such as having a good ordering experience, or having a conversation with your barista. <br/><br/>
        The commitment to creating genuinely good human experiences acknowledges 
        that we’re going to be more than just making drinks, that our emphasis is what we can do that machines can’t, or what fast food will never choose to offer. <br/><br/>
        The commitment to having our whole environment and service mentality in making sure that the experience from walking in, to walking out, was a genuinely good experience 
        for not only the customer, but also for the staff, and every other human involved in that community - from our suppliers, to our team, to our customers, we strive to make 
        sure that every part of that relationship chain is a wholesome experience.`
    },
    brewsSection: {
      sectionTitle: "Brews",
      header: [
        "Nitro Tea",
        "Pour Over Coffee",
        "Siphon Pot Coffee and Tea",
        "Cold Drip Tea",
      ],
      description: [
        `
          Using exclusively our cold drip or cold brewed teas and coffees, we keg them, chill them, then nitrogenate them for a wonderfully full bodied draught. 
          Although 
          looking deceptively like beer, this extremely refreshing drink has a full mouth-feel that is extremely easy to drink. 
          <br/>
          <br/>
          Perfect for relaxing, and perfect for thirst 
          quenching. Our favourite way to quench our thirst.
        `,
        `
          Although we are primarily a tea house, we believe in doing things right. 
          <br/>
          <br/>
          We have partnered with our favourite local coffee roaster, Pilot Coffee Roasters, 
          in order to bring our customers the very best.
          Meticulous pour-overs we have refined over the years. We bring to you our vision of what a perfectly balanced 
          cup of coffee should be. Just enough acidity, plenty of body, and a smooth rounded finish. By meticulously adjusting every variable of the grind, the water, 
          and the pour, our goal is a balanced flavour profile that brings out the best of every roast.
        `,
        `
          This is a wonderful brewing method that extracts a bold yet smooth flavour from both tea and coffee. When heated, water in a sealed chamber gets pushed up to 
          the awaiting tea or coffee in the chamber above, at a perfect temperature for brewing. Unlike steeping, this process keeps the temperature consistent to allow 
          for a controlled extraction using nothing but time. 
          <br/>
          <br/>
          When the right time is reached for perfect extraction, our baristas cool the bottom chamber to let all the 
          wonderful brew siphon back into the serving pot - hence the name, resulting in a delicious cup every time.
        `,
        `
          This one is for the tea purist at heart. We believe that half the battle of an amazing cup of tea is the tea itself, and the other half is how it’s prepared. 
          Sourcing high quality teas through our award winning tea partner Tao Tea Leaf, we’re doing nothing but justice to these great leaves.
          <br/>
          <br/>
          Starting with a perfectly weighed portion of tea, we cold drip for over 8 hours, meticulously adjusting the drip throughout the course of the day to ensure 
          consistent extraction. This method brings out all the best aromas and flavours the tea has to offer, without any of the harsher notes. Teas that are perfectly 
          great brewed hot, share another delicate side of themselves when brewed through this method. 
        `,
      ],
    },
    mixesSection: {
      sectionTitle: "Mixes",
      header: [
        "Nothin’ but the tea, Milk tea",
        "MF Tea",
        "Not Your Basic Iced Tea",
        "bbtease Signature Smoothies",
        "Fresh Tapioca & Toppings"
      ],
      description: [
        
        `
          No artificial flavours. No milk powders. No fructose. No corn syrup. Just good ol’ high quality tea, milk, cream, 
          and natural simple syrups made in house. Our goal is to showcase the best and most delicate nuances the tea has to offer, 
          without resorting to fake flavours. 
          <br/>
          <br/>
          To make a balanced, light, and refreshing milk tea that doesn’t leave a film in your mouth, 
          and leaves out the harsh bitter aftertaste that comes with oversteeped tea. Perfectly balanced, as all things should be.
        `,
  
        `
          Our milk foam teas are rich, creamy, and packed with premium tea flavour. 
          No artificial flavours, all natural, and deliciously decadent. 
          With no cream added, yet just as rich, our MF Teas are a perfect alternative to our classic milk teas.
        `,

        `
          Drawing on our team’s experience and passion for mixology, tea, coffee, and culinary arts, we are creating what we’ve always wanted iced tea to
          be. 
          <br/>
          <br/>
          Delicious, all natural, packed with flavour, honest, yet indulgent. Starting with meticulously brewed tea, with an emphasis
          on bringing out the tea’s flavour without excessive bitterness, we aim for a balanced profile. Our next step is to add natural 
          fruit syrups that are made in house, through cold press and reduction methods, as various herbs and garnishes to bring out the best the tea has to offer. 
          We choose specific flavour profiles that promote a balanced flavour profile.
        `,
        `
          Smoothies with honestly laid out ingredients. We’re not hiding any fluff or artificial flavourings. What you see is what you get.
          <br/>
          <br/> 
          Each smoothie we craft is a blend of several whole fruits, our premium brewed tea, our house made simple syrup, and various other 
          natural ingredients to balance out each flavour profile. Each smoothie is its own unique experience. Our goal was to create a 
          wonderful flavour profile from start to finish with every sip.
        `,
        `
          We could have gone with a hundred different varieties of toppings, but we believe that sometimes, less is more. By going with only 
          a small handful of offerings, and focusing specifically on Tapioca, we are able to ensure a consistently fresh, and consistently delicious 
          boba every time. 
          <br/>
          <br/>
          Not too soft, not too hard, just chewy enough. Not too sweet, yet just sweet enough. Our goal is balance, as we believe that’s 
          what makes these balls so damn good. Cooked in small batches every few hours throughout the day, our process ensures your tapioca is 
          always fresh, and always delicious.
        `,
      ],
    },
    locationSection: {
      texts: [
        "Tuesday - Sunday from 2pm - 8pm",
        "111 Dundas St W, Toronto, Ontario, M5G1C4",
        "437-917-9349"
      ],
    },
};